<template>
  <div>
    <div class="Search_head_area">
      <div class="Search_head">
        <span style="text-transform:capitalize;">{{ search }}</span>
      </div>
      <div
        v-if="search"
        class="Search_deselect"
        @click="$emit('onDeselect')"
      >
        <span>選択を解除</span>
      </div>
    </div>
    <div class="Archives__area">
      <div v-for="(scheduleMelonTVOfDate,date) of listMelonTVs" :id="`date-${date}`" :key="date" class="Archives__box">
        <div class="Archives__box_left">
          <div class="Archives__box_date">
            {{ showDate(date) }}
          </div>
          <div class="Archives__box_line" />
          <div class="Archives__box_line_hide" />
        </div>
        <div class="Archives__box_right Card__archives_area">
          <div
            v-for="(item,key) of scheduleMelonTVOfDate"
            :key="key"
            class="Archives_class_box"
            @click="openModalSchedule(item.id)"
          >
            <div
              class="Card__box Card__box--sm"
              :style="parseCssVars(item.master_program_category)"
            >
              <div class="Card__box_label Card__box_label_secondary">
                <div class="Label Label__time Card__box_time_label_secondary">
                  {{ item.time }} 分
                </div>
                <span class="Card__box_label_time">
                  <img
                    :src="item.master_program_category.c_icon_url"
                    alt="icon"
                    class="Card__box_label_icon"
                  >
                  {{ item.learning_time }}
                </span>
                <span class="Card__box_label_class">
                  {{ item.title }}
                </span>
                <span class="Card__box_label_name">
                  <img
                    :src="showAvatar(item.master_instructor)"
                    alt="avatar"
                    class="Card__box_label_avatar"
                  >
                  {{ item.master_instructor.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import melontvService from '@/services/melontvService'
import moment from 'moment'
import request from '@/helpers/request'
import { convertAvatar } from '@/helpers'
import { parseCssVars } from '@/helpers/programCategory'

export default {
  name: 'MelonTVSearchSchedule',
  props: {
    searchObj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      listMelonTVs: {},
      isModalMelonTV: false,
      melontvDetail: {},
      search: '',
      nextPage: null,
      isFetching: false
    }
  },
  watch: {
    searchObj: async function() {
      await this.getListMelonTVs()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      window.onscroll = this.handleScroll
      await this.getListMelonTVs()
    },
    async handleScroll() {
      const bottomOfWindow = Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight + 50 >= document.documentElement.offsetHeight
      if (this.nextPage && bottomOfWindow && !this.isFetching) {
        this.isFetching = true
        let tries = 0
        let success = false
        while (!success && tries < 3) {
          const response = await request.get(this.nextPage)
          if (response.data) {
            this.handleListMelonTVs(response.data, true)
            this.nextPage = response.next_page_url
            success = true
          }
          tries++
        }
        this.isFetching = false
      }
    },
    showTime(time) {
      return time + ' 分'
    },
    handleListMelonTVs(list, isAppend = false) {
      let listDate = {}
      if (isAppend) {
        listDate = { ...this.listMelonTVs }
      }
      list.forEach(function(item, key) {
        const date = moment(item.date).format('YYYY-MM-DD')
        if (typeof listDate[date] !== 'undefined') {
          listDate[date].push(item)
        } else {
          listDate[date] = [item]
        }
      })
      this.listMelonTVs = listDate
    },
    async getListMelonTVs() {
      this.$store.dispatch('loading/updateLoading', true)
      if (typeof this.searchObj.searchTime !== 'undefined') {
        this.search = this.searchObj.searchTime + '分'
        const response = await melontvService.search(this.searchObj.searchTime)
        this.handleListMelonTVs(response.data)
        this.nextPage = response.next_page_url
      } else
      if (typeof this.searchObj.searchDay !== 'undefined') {
        this.search = this.searchObj.searchDay
        const response = await melontvService.searchDay(this.searchObj.searchDay)
        this.handleListMelonTVs(response.data)
        this.nextPage = response.next_page_url
      } else
      if (typeof this.searchObj.searchCategory !== 'undefined') {
        this.search = this.searchObj.name
        const response = await melontvService.searchClass(this.searchObj.searchCategory)
        this.handleListMelonTVs(response.data)
        this.nextPage = response.next_page_url
      } else
      if (typeof this.searchObj.searchInstructor !== 'undefined') {
        this.search = this.searchObj.name
        const response = await melontvService.searchInstructor(this.searchObj.searchInstructor)
        this.handleListMelonTVs(response.data)
        this.nextPage = response.next_page_url
      }
      this.$store.dispatch('loading/updateLoading', false)
    },
    showDate(date) {
      return moment(date).locale('ja').format('MMMDo(ddd)')
    },
    openModalSchedule(scheduleId) {
      this.$store.dispatch('modal/openModalMelonTV', scheduleId)
    },
    showAvatar(instructor) {
      let url = null
      if (instructor) {
        url = instructor.image_url
      }
      return convertAvatar(url)
    },
    parseCssVars: parseCssVars
  }
}
</script>
